import { Button } from '@shared/components/shadcn';
import { Error as ErrorIcon } from '@shared/icons/system';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { UnsubscribePageContainer } from '..';
import { Link } from '../../Link/Link';

type UnsubscribeScreenErrorProps = {
  isFetchingError: boolean;
  reset: () => void;
};

const { MY_ACCOUNT } = ROUTES;

/**
 * Component to display an error message screen when the unsubscribe data fetching fails
 * @param isFetchingError - Whether the fetching error occurred (muttation error screen is slightly different)
 * @param reset - Function to reset the unsubscribe state (when mutation fails)
 * @returns A component to display an error message when fetching unsubscribe data fails
 */
function UnsubscribeScreenError({ isFetchingError, reset }: UnsubscribeScreenErrorProps) {
  const t = useTranslations('unsubscribe');
  return (
    <UnsubscribePageContainer data-track-container="Failure Confirmation">
      <UnsubscribePageContainer.NotificationContainer>
        <ErrorIcon size="extra-extra-large" className="self-center" />
        <p className="text-center">{t('error_fetching_data')}</p>
        {isFetchingError ? (
          <Link href={MY_ACCOUNT.SETTINGS()} className="text-primary underline" data-testid="manage-preferences-link" data-track-name="Manage Preferences">
            {t('manage_preferences')}
          </Link>
        ) : (
          <Button variant="primary" size="m" className="self-center" onClick={reset} data-track-name="Retry">
            {t('try_again')}
          </Button>
        )}
      </UnsubscribePageContainer.NotificationContainer>
    </UnsubscribePageContainer>
  );
}

export { UnsubscribeScreenError };
